/**
 * Must be called before the Vue app is mounted.
 * Moves JSON and LD+JSON scripts from <body> to <head> to prevent Vue 3 from
 * removing them when the app mounts.
 */
export function hoistJsonScripts() {
  try {
    const fragment = document.createDocumentFragment();
    document.body
      .querySelectorAll('script[type="application/json"], script[type="application/ld+json"]')
      .forEach((script) => {
        fragment.appendChild(script);
      });
    document.head.appendChild(fragment);
  } catch (error) {
    console.error('Error hoisting JSON scripts:', error);
  }
}
